<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="TITLE">toughest people to love</p>
<p class="SUBTITLE">how to understand, lead, and love <br/>the difficult people in your life — <br/><em class="italic">including yourself</em></p>
<p class="AUTHOR">Chuck DeGroat</p>
<p class="COMPANY"><span class="sc">William B. Eerdmans Publishing Company<br/></span>Grand Rapids, Michigan / Cambridge, U.K.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// DeGroat_Toughest_People_to_Love_text.vue?2aa6f4ba